/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ChatbotRegular from './chatbot-regular-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ChatbotRegular {...validProps} />;
}

SvgComponent.iconName = 'chatbotRegular';

export const ChatbotRegularIcon = svgIconWrapper(SvgComponent);
